import { ContentObjectItem } from "@vertesia/common"

import { DocumentOverlay } from "@components/overlays/DocumentOverlay"

interface DashboardDocumentButtonProps {
    document: ContentObjectItem
}
export function DashboardDocumentButton({ document }: Readonly<DashboardDocumentButtonProps>) {
    return (
        <DocumentOverlay document={document.id}>
            <div key={document.id} className="flex flex-col w-full hover:cursor-pointer p-1 rounded-lg hover:cursor-pointer hover:bg-gray-100">
                <div className="flex flex-row flex-1 items-center gap-1 min-w-0">
                    <p className="text-sm font-bold truncate w-full">{document.name}</p>
                </div>
                <p className="text-xs text-muted-foreground">Updated {timestampToDate(new Date(document.updated_at).getTime() / 1000)}</p>
            </div>
        </DocumentOverlay>
    )
}

function timestampToDate(timestamp: number) {
    if (!timestamp) {
        return "Unknown"
    }

    const date = new Date(timestamp * 1000)
    const currentDate = new Date()

    const diffMs = currentDate.getTime() - date.getTime()
    const diffSeconds = Math.floor(diffMs / 1000)
    const diffMinutes = Math.floor(diffSeconds / 60)
    const diffHours = Math.floor(diffMinutes / 60)
    const diffDays = Math.floor(diffHours / 24)
    const diffWeeks = Math.floor(diffDays / 7)
    const diffMonths = Math.floor(diffDays / 30)
    const diffYears = Math.floor(diffDays / 365)

    if (diffSeconds < 60) {
        return diffSeconds === 1 ? "1 second ago" : `${diffSeconds} seconds ago`
    } else if (diffMinutes < 60) {
        return diffMinutes === 1 ? "1 minute ago" : `${diffMinutes} minutes ago`
    } else if (diffHours < 24) {
        return diffHours === 1 ? "1 hour ago" : `${diffHours} hours ago`
    } else if (diffDays <= 7) {
        return diffDays === 1 ? "1 day ago" : `${diffDays} days ago`
    } else if (diffWeeks <= 4) {
        return diffWeeks === 1 ? "1 week ago" : `${diffWeeks} weeks ago`
    } else if (diffMonths < 12) {
        return diffMonths === 1 ? "1 month ago" : `${diffMonths} months ago`
    } else {
        return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`
    }
}
